import { useUSDCBalance } from '@audius/common/api'

export const USDCBalanceFetcher = () => {
  useUSDCBalance()
  return null
}
